import VLabel from '../../GENIO/components/GLabel/GLabel'

export { VLabel }
export default VLabel
